import styled from 'styled-components';

const Container = styled.div`
  width: 100px;
  text-align: right;
  flex-shrink: 0;
`;

export default Container;
